import PropTypes from "prop-types";
import React from "react";

import { WsExceptionStatus } from "./ws-exception-status";
import { WsOnlineStatus } from "./ws-online-status";

class WsConnStatus extends React.PureComponent {
  static get propTypes() {
    return {
      connection: PropTypes.object,
      dispatch: PropTypes.func,
    };
  }

  render() {
    // eslint-disable-next-line no-unused-vars
    const { connection, dispatch, ...rest } = this.props;
    const { wsException, wsOnline } = connection || {};

    return (
      <div className="ws-conn-status">
        <div {...rest}>
          <WsOnlineStatus online={wsOnline} />
          <WsExceptionStatus exception={wsException} />
        </div>
      </div>
    );
  }
}

export { WsConnStatus };
